import React from 'react';
import styled from 'styled-components';

import { useMedia } from '@tager/web-core';

import CarPrice from '@/components/CarPrice';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import { getCarsStockPriceText } from '@/utils/common';
import { usePhoneNumber } from '@/hooks/usePhoneNumber';

function Price() {
  const data = useTypedSelector(selectDetailedCarData);
  const isMobile = useMedia('(max-width: 767px)');
  const phone = usePhoneNumber();

  if (!data) {
    return null;
  }

  const { pricing } = data;

  const price = !pricing?.price
    ? {
        text: getCarsStockPriceText(phone, false),
      }
    : {
        amount: pricing.tradeInPrice
          ? pricing.tradeInPrice
          : pricing.discountPrice
          ? pricing.discountPrice
          : pricing.price,
        discount: pricing.discountPrice
          ? pricing.price - pricing.discountPrice
          : undefined,
        tradeIn: pricing.tradeInPrice
          ? pricing.price - pricing.tradeInPrice
          : undefined,
      };

  return (
    <Component>
      <CarPrice {...price} isMobile={isMobile} />
    </Component>
  );
}

export default Price;

const Component = styled.div`
  margin-top: 10px;
`;
